export default __webpack_public_path__ + "static/Muhammad_Umair-3feebf0cdaf4301211de4014c1219329.jpg";